module.exports = __webpack_public_path__ + "static/img/bg_high@3x.9bd5079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_high@3x.png
// module id = zHvb
// module chunks = 1